import ICON_STYLES from "../Reducers/iconStyles.json";

/**
 * Each icon's drawing style for the Style filter: "line", "solid" or "duotone".
 * Line and solid come from scripts/icon-grid/classify-style.js; an icon it hasn't
 * tagged yet (a new drawing) counts as solid until the script is rerun.
 */
export const iconStyle = (icon) =>
  icon.isDuotone ? "duotone" : ICON_STYLES[`${icon.cat}/${icon.name}`] || "solid";

export const matchesStyle = (styleFilter, icon) =>
  styleFilter === "all" || iconStyle(icon) === styleFilter;

// Icons per category for each style, e.g. { chart: { line: 4, solid: 9 } }
const STYLE_COUNTS = Object.keys(ICON_STYLES).reduce((counts, key) => {
  const cat = key.slice(0, key.indexOf("/"));
  const style = ICON_STYLES[key];
  counts[cat] = counts[cat] || {};
  counts[cat][style] = (counts[cat][style] || 0) + 1;
  return counts;
}, {});

// How many of a category's icons the filter shows
export const styleCount = (styleFilter, category) => {
  if (styleFilter === "all") return category.total;
  if (category.cat_name === "duotone") return styleFilter === "duotone" ? category.total : 0;
  if (styleFilter === "duotone") return 0;
  return (STYLE_COUNTS[category.cat_name] || {})[styleFilter] || 0;
};
